<div class="fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center items-center animate-fade-in" style="z-index: 1000000;">
    <div class="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden">
        <!-- Header with severity indicator -->
        <div class="flex items-center gap-4 p-6 bg-red-50 border-b border-red-100">
            <div class="flex-shrink-0 w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
                <svg class="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
                </svg>
            </div>
            <div>
                <h3 class="text-lg font-semibold text-gray-900">Confirm Action</h3>
                <p class="text-sm text-gray-600">This action cannot be undone.</p>
            </div>
        </div>

        <!-- Message -->
        <div class="p-6">
            <p class="text-gray-700">{{ message }}</p>
        </div>

        <!-- Actions -->
        <div class="flex justify-end gap-3 p-4 bg-gray-50 border-t border-gray-100">
            <button
                (click)="onCancel()"
                class="px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer">
                Cancel
            </button>
            <button
                (click)="onOk()"
                class="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-lg transition-colors cursor-pointer
                       focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2">
                Delete
            </button>
        </div>
    </div>
</div>
